"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var KlarnaConfig = /*#__PURE__*/function () {
  function KlarnaConfig(helpers, klarnaWidgetEnabled) {
    var _this = this;
    _classCallCheck(this, KlarnaConfig);
    _defineProperty(this, "onSubmit", function (state, component) {
        _this.helpers.assignPaymentMethodValue();
      _this.helpers.paymentFromComponent(state.data, component);
    });
    _defineProperty(this, "onAdditionalDetails", function (state) {
      _this.document.querySelector('#additionalDetailsHidden').value = JSON.stringify(state.data);
      _this.document.querySelector('#showConfirmationForm').submit();
    });
    _defineProperty(this, "onError", function (component) {
      _this.helpers.paymentFromComponent({
        cancelTransaction: true,
        merchantReference: document.querySelector('#merchantReference').value,
        orderToken: document.querySelector('#orderToken').value
      }, component);
      document.querySelector('#showConfirmationForm').submit();
    });
    this.helpers = helpers;
    this.klarnaWidgetEnabled = klarnaWidgetEnabled;
    this.document = document;
  }
  return _createClass(KlarnaConfig, [{
    key: "getConfig",
    value: function getConfig() {
      if (this.klarnaWidgetEnabled) {
        return {
          showPayButton: true,
          useKlarnaWidget: true,
          onSubmit: this.onSubmit,
          onAdditionalDetails: this.onAdditionalDetails,
          onError: this.onError
        };
      }
      return null;
    }
  }]);
}();
module.exports = KlarnaConfig;